$(function () {
  $('.search-bonkers').on('focus', function () {
    $('.search-box .fa-search').css('color', Bonkers.colours.green);
  }).on('blur', function () {
    $('.search-box .fa-search').css('color', Bonkers.colours.marine);
  });
});
